
import { Bar, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;
declare var Chart: any;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartName: {
      type: String,
      default: '',
    },
    chartData: {
      type: Object,
      default: null,
    },
    legendName: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: null,
    },
    gradient: {
      type: Array,
      default: null,
    },
  },
  mounted() {
    var ctx = (document.getElementById(
      (this as any).chartName
    ) as any).getContext('2d');
    var chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: (this as any).chartData.labels,
        datasets: [
          {
            label: (this as any).legendName,
            backgroundColor: (this as any).chartData.datasets.backgroundColor,
            data: (this as any).chartData.datasets.data,
          },
        ],
      },
      options: {
        events: false,
        tooltips: {
          enabled: false,
          callbacks: {
            label: function(tooltipItem, data) {
              var value = data.datasets[0].data[tooltipItem.index];
              value = value.toString();
              value = value.split(/(?=(?:...)*$)/);
              value = value.join('.');
              return value;
            },
          },
        },
        hover: {
          animationDuration: 0,
        },
        animation: {
          duration: 1,
          onComplete: function() {
            var chartInstance = (this as any).chart;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';

            (this as any).data.datasets.forEach(function(dataset, i) {
              var meta = chartInstance.controller.getDatasetMeta(i);
              meta.data.forEach(function(bar, index) {
                var data =
                  '' +
                  dataset.data[index]
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                ctx.fillText(data, bar._model.x, bar._model.y - 5);
              });
            });
          },
        },
        legend: {
          // display: false,
          position: 'bottom'
        },
        scales: {
          yAxes: [
            {
              ticks: {
                // display: false,
                beginAtZero: true,
                // steps: 10,
                // stepValue: 6,
                // fontSize: 1,
                userCallback: function(value, index, values) {
                  value = value.toString();
                  value = value.split(/(?=(?:...)*$)/);
                  value = value.join('.');
                  return value;
                },
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                // fontSize: 10,
                // maxRotation: 45,
                // minRotation: 45
              },
            },
          ],
        },
        layout: {
          padding: {
            //   left: 90,
            //   right: 20,
            top: 20,
            //   bottom: 20
          },
        },
      },
    });
  },
};
